


function footer() {
    return <section className="align-page bg-body bg-grey text-center font-12">Copyright © 2023 The Band Malhar. All Rights Reserved.</section>

}

export default footer;